import * as Audio from './audioAds/externals';
import * as DisplayAds from './displayAds/externals';
import * as MediaAds from './mediaAds/externals';
import * as Rewards from './rewards/externals';
import * as Video from './videoAds/externals';

export const Actions = Object.freeze({
  AD_OPPORTUNITY: 'AD_OPPORTUNITY',
  AD_REQUEST_IN_FLIGHT: 'AD_REQUEST_IN_FLIGHT',
  ADS_AD_DATA_UPDATED: 'ADS_AD_DATA_UPDATED',
  CLEAR_PA_VIDEO_STATS: 'CLEAR_PA_VIDEO_STATS',
  HANDLE_TILE: 'HANDLE_TILE',
  LOG_DISPLAY_ADS_THROUGH_APS_EXPOSURE_EVENT: 'LOG_DISPLAY_ADS_THROUGH_APS_EXPOSURE_EVENT',
  SET_EXTERNAL_AD_IDENTIFIERS: 'SET_EXTERNAL_AD_IDENTIFIERS',
  SET_PA_VIDEO_STATS: 'SET_PA_VIDEO_STATS',
});

export const AdLifecycleActions = Object.freeze({
  AD_LIFECYCLE_AD_OPPORTUNITY_END: 'ad_lifecycle_ad_opportunity_end',
  AD_LIFECYCLE_AD_OPPORTUNITY_ERROR: 'ad_lifecycle_ad_opportunity_error',
  AD_LIFECYCLE_AD_OPPORTUNITY_START: 'ad_lifecycle_ad_opportunity_start',
});

export const LifeCycleType = Object.freeze({
  AUDIO: 'audio',
  VIDEO: 'video',
});

export const AdAnalyticsKeys = Object.freeze([
  'action',
  'reason',
  'station_id',
  'trigger_action',
  'status',
]);

export { Audio, DisplayAds, MediaAds, Rewards, Video };
